export default __webpack_public_path__ + "static/media/class_xi_xii_engg.f46be3e9.png";